/* @ngInject */

export default (
  $rootScope,
  AssetFinanceInsuranceType,
  dateTimeService,
  PaymentFrequency
) => {
  /*
   * Constructor
   * --------------------------------------------------------------------------------
   */
  function AssetFinanceInsurance(
    id,
    insuranceType,
    name,
    policyNumber,
    premiumEndDate,
    premiumAmount,
    isCapitalized,
    premiumFrequency,
    policyNotes,
    timeStamp
  ) {
    this.id = id;
    this.insuranceType = insuranceType;
    this.name = name;
    this.policyNumber = policyNumber;
    this.premiumEndDate = premiumEndDate;
    this.premiumAmount = premiumAmount;
    this.isCapitalized = isCapitalized;
    this.premiumFrequency = premiumFrequency;
    this.policyNotes = policyNotes;
    this.timeStamp = timeStamp;
  }

  /*
   * Static Methods
   * --------------------------------------------------------------------------------
   */
  AssetFinanceInsurance.Blank = function (insuranceType) {
    return AssetFinanceInsurance.Build({
      id: _.uuid(),
      insuranceType: AssetFinanceInsuranceType.Build(insuranceType),
      name: '',
      policyNumber: '',
      premiumEndDate: 0,
      premiumAmount: 0,
      isCapitalized: false,
      premiumFrequency: PaymentFrequency.monthly,
      policyNotes: '',
      timeStamp: dateTimeService.epoch()
    });
  };

  AssetFinanceInsurance.Build = function (data) {
    return new AssetFinanceInsurance(
      data.id ? data.id : _.uuid(),
      data.insuranceType
        ? AssetFinanceInsuranceType.Build(data.insuranceType)
        : AssetFinanceInsuranceType.Build(),
      data.name ? data.name : '',
      data.policyNumber ? data.policyNumber : '',
      data.premiumEndDate ? parseFloat(data.premiumEndDate || 0) : 0,
      data.premiumAmount ? parseFloat(data.premiumAmount || 0) : 0,
      data.isCapitalized ? data.isCapitalized : false,
      data?.premiumFrequency
        ? PaymentFrequency.of(data?.premiumFrequency?.name || `f${data?.premiumFrequency}`)
        : PaymentFrequency.monthly,
      data.policyNotes ? data.policyNotes : '',
      data.timeStamp ? data.timeStamp : dateTimeService.epoch()
    );
  };

  /*
   * Public methods
   * --------------------------------------------------------------------------------
   */
  AssetFinanceInsurance.prototype.getName = function () {
    return this.name;
  };
  AssetFinanceInsurance.prototype.getAssetFinanceInsuranceTypeName = function () {
    return this.insuranceType.name;
  };
  AssetFinanceInsurance.prototype.getSetInsurancePremiumEndDate = function (date) {
    if (arguments.length) {
      if (arguments[0] !== null) {
        if (this.premiumEndDate === 0) {
          this.premiumEndDateObject = '';
        }
        const premiumEndDateObject = dateTimeService.setDate(
          date,
          $rootScope.CurrentTimeZone(),
          true
        );
        this.premiumEndDateObject = date;
        this.premiumEndDate = moment.utc(premiumEndDateObject).startOf('day').format('X');
      } else {
        this.premiumEndDateObject = date;
        this.premiumEndDate = '';
      }
    }
    if (!this.premiumEndDateObject) {
      if (this.premiumEndDate) {
        const premiumEndDateObject = dateTimeService.setDate(
          this.premiumEndDate,
          $rootScope.CurrentTimeZone(),
          false
        );
        this.premiumEndDateObject = premiumEndDateObject;
      } else {
        this.premiumEndDateObject = '';
      }
    }
    return this.premiumEndDateObject;
  };
  AssetFinanceInsurance.prototype.getInsurancePremiumEndDate = function (timeZone, format) {
    return this.premiumEndDate
      ? moment
          .utc(this.premiumEndDate, 'X')
          .tz(timeZone || 'UTC')
          .format(format || 'LL')
      : 'N/A';
  };
  AssetFinanceInsurance.prototype.getDate = function () {
    return dateTimeService.getFormattedDate(this.timeStamp);
  };
  AssetFinanceInsurance.prototype.getTime = function () {
    return dateTimeService.getFormattedTime(this.timeStamp);
  };
  AssetFinanceInsurance.prototype.deleteDateObject = function () {
    delete this.premiumEndDateObject;
  };

  return AssetFinanceInsurance;
};
